export default [
    {
        icon: 'clinic-medical',
        name: 'HOME',
        // route: 'home', 
        route: 'home.home-dashboard.index', 
        children: [],
        expand:false
    },
    {
        icon: 'book-medical',
        name: 'REGISTRATION',
        expand:false,
        children: [
            {
                icon: 'list',
                name: 'Patient Management',
                route: 'registration.patient-management.index',
            },
            {
                icon: 'list',
                name: `Current Visits`,
                route: `registration.current-visits.create`,
            },
        ],
    },
    {
        icon: 'syringe',
        name: 'OUTPATIENTS',
        expand:false,
        children: [
            {
                icon: 'list',
                name: 'Patient Queue',
                route: 'outpatient.outpatient-list.index',
            },
        ],
    },
    {
        icon: 'laptop-medical',
        name: 'ADMISSION',
        expand:false,
        children: [
            {
                icon: 'list',
                name: 'Admission Queue',
                route: `admissions.admission-queue.index`,
            },
            {
                icon: 'list',
                name: 'Current Inpatients',
                route: `admissions.current-inpatients.index`,
            },
            {
                icon: 'plus',
                name: 'Pending Discharge',
                route: `admissions.pending-discharge.index`
            },
            {
                icon: 'plus',
                name: 'Dicharged Patients',
                route: `admissions.discharged-patients.index`,
            },
        ],
    },
    {
        icon: 'procedures',
        name: 'INPATIENTS',
        expand:false,
        children: [
            {
                icon: 'list',
                name: 'Current Inpatients',
                route: 'inpatients.list.index',
            },{
                icon: 'list',
                name: 'Progress Notes',
                route: 'inpatients.progressnotes.index',
            },{
                icon: 'list',
                name: 'Daily Report',
                route: 'inpatients.dailyreport-list.index',
            },{
                icon: 'list',
                name: 'Common Diagnosis',
                route: 'inpatients.commondiagnosis-list.index',
            },
            {
                icon: 'plus',
                name: 'Orders',
                route: 'inventory-management.orders.index'
            },
        ],
    },
    {
        icon: 'hand-holding-usd',
        name: 'BILLING',
        expand:false,
        children: [
            {
                icon: 'list',
                name: 'Select patient',
                route: 'billing.patients.index',
            },
            {
                icon: 'plus',
                name: 'Cash Out',
                route: 'billing.cash-out.create'
            },
            {
                icon: 'plus',
                name: 'Reversals',
                route: 'billing.reversals.create'
            },
            {
                icon: 'plus',
                name: 'Cancel Unposted Bills',
                route: 'billing.cancel-unposted-bills.create'
            },
            {
                icon: 'plus',
                name: 'Approvals',
                route: 'billing.approvals.index'
            },{
                icon: 'plus',
                name: 'Direct MPesa/Bank Payments ',
                route: 'reports.accounts-finance.mpesa-pay-report.index'
            },
            
            // {
            //     icon: 'plus',
            //     name: 'Consultants',
            //     route: 'billing.consultant-dashboard.index'
            // },
        ],
    },
    {
        icon: 'pills',
        name: 'PHARMACY',
        expand:false,
        children: [
            {
                icon: 'list',
                name: 'Queue & Requisitions',
                route: 'pharmacy.dashboard',
            },
            {
                icon: 'plus',
                name: 'Issue Report',
                route: 'reports.pharmacy-issue-report.index'
            },
            {
                icon: 'plus',
                name: 'OutPatient Summary Report',
                route: 'reports.pharmacy-outpatientsummary-report.index'
            },
        ],
    },
    {
        icon: 'x-ray',
        name: 'RADIOLOGY',
        expand:false,
        children: [
            {
                icon: 'list',
                name: 'Queue',
                route: 'radiology.patients.index',
            },
            {
                icon: 'list',
                name: 'Past Queue',
                route: 'radiology.past-queue.index',
            },{
                icon: 'list',
                name: 'Reporting Queue',
                route: 'radiology.reporting-queue.index',
            },
            {
                icon: 'plus',
                name: 'Completed Investigations',
                route: 'radiology.completed-investigations.index'
            },
            {
                icon: 'plus',
                name: 'Orders',
                route: 'inventory-management.orders.index'
            },
        ],
    },
    {
        icon: 'microscope',
        name: 'LAB',
        expand:false,
        children: [
            {
                icon: 'plus',
                name: 'Lab Queue',
                route: 'lab.queue.index'
            },
            {
                icon: 'plus',
                name: 'Past Lab Queue',
                route: 'lab.past-queue.index'
            },
            {
                icon: 'plus',
                name: 'Previous Lab Results',
                route: 'lab.previous-results.index'
            },
            {
                icon: 'plus',
                name: 'Lab Report',
                route: 'lab.report.index'
            },
            {
                icon: 'plus',
                name: 'Orders',
                route: 'inventory-management.orders.index'
            },
        ],
    },
   
    // {
    //     icon: 'prescription',
    //     name: 'RENAL',
    //     expand:false,
    //     children: [
    //         {
    //             icon: 'list',
    //             name: 'Queue',
    //             route: 'renal.queue.index',
    //         },
    //     ],
    // },
    {
        icon: 'cut',
        name: 'THEATRE',
        expand: false,
        children: [
            {
                icon: 'plus',
                name: 'Procedure Queue',
                route: 'theatre.procedure-queue.index'
            },
            {
                icon: 'plus',
                name: 'Past Procedure Queue',
                route: 'theatre.past-procedure-queue.index'
            },
            {
                icon: 'plus',
                name: 'Completed Procedures',
                route: 'theatre.previous-procedures.index'
            },
            {
                icon: 'plus',
                name: 'Procedure List',
                route: 'theatre.procedure-list.index'
            },
            {
                icon: 'plus',
                name: 'Procedure List',
                route: 'theatre.procedure-list2.index'
            },
            {
                icon: 'plus',
                name: 'Orders',
                route: 'inventory-management.orders.index'
            },
        ],
    },
    {
        icon: 'folder',
        name: 'CLAIMS',
        expand:false,
        children: [],
        route: `claims.index`
    },
   
    
    {
        icon: 'boxes',
        name: 'INVENTORY',
        route: 'inventory-management.index',
        expand:false,
        children: [],
    },
    {
        icon: 'people-carry',
        name: 'SUPPLIERS',
        route: `suppliers-dashboard.index`,
        expand:false,
        children: [],
    },
    {
        icon: 'clipboard',
        name: 'AUDITING',
        route: `auditing.auditing-dashboard.index`,
        expand:false,
        children: [],
    },
    // {
    //     icon: 'file-invoice-dollar',
    //     name: 'FINANCE',
    //     route: `finance-dashboard.index`,
    //     expand:false,
    //     children: [],
    // },
    {
        icon: 'file-invoice-dollar',
        name: 'FINANCE',
        expand:false,
        children: [
            {
                icon: 'list',
                name: 'Bill Payments',
                route: 'finance-dashboard.bill-payments.create',
            },
             
            {
                icon: 'plus',
                name: 'Expenses Managment',
                route: 'finance-dashboard.expenses.index'
            }, {
                icon: 'plus',
                name: 'Asset Managment',
                route: 'finance-dashboard.assets.index'
            },
            {
                icon: 'plus',
                name: 'Bank Deposit',
                route: 'finance-dashboard.banking.deposit'
            },
            {
                icon: 'plus',
                name: 'Bank Reconciliation',
                route: 'finance-dashboard.banking.reconciliations'
            }, {
                icon: 'plus',
                name: 'Journal Entry',
                route: 'finance-dashboard.coas.journalentries'
            }, {
                icon: 'plus',
                name: 'Chart Of Accounts',
                route: 'master-data.accounts.coas.index'
            }, {
                icon: 'plus',
                name: 'Financial Periods',
                route: 'master-data.accounts.financial-periods.index'
            },
            {
                icon: 'list',
                name: 'COA Reports',
                route: 'finance-dashboard.coas.index',
            }
            // ,  {
            //     icon: 'list',
            //     name: 'Cash Sales',
            //     route: 'finance-dashboard.cashsales.index',
            // },
        ],
    },
    {
        icon: 'wallet',
        name: 'POS',
        expand: false,
        children: [
            {
                icon: 'plus',
                name: 'Sales',
                route: 'sales.index'
            },
            // {
            //     icon: 'list',
            //     name: 'Sales History',
            //     route: 'sales.index'
            // },
            
            {
                icon: 'list',
                name: 'Pending Sales',
                route: 'sales.pendingsales'
            },{
                icon: 'list',
                name: 'Sales Report',
                route: 'sales.report'
            }, {
                icon: 'list',
                name: 'Reverse Sales ',
                route: 'sales.reverse'
            },
            
            {
                icon: 'box',
                name: 'Sale Per Item Report',
                route: 'sales.per-item.report'
            },
        ],
    },
     {
        icon: 'pallet',
        name: 'MORGUE',
        expand:false,
        children: [
            {
                icon: 'list',
                name: 'Admit to morgue',
                route: 'morgue.admissions.index',
            },
            {
                icon: 'list',
                name: 'In Morgue',
                route: 'morgue.queue.index',
            },
            {
                icon: 'plus',
                name: 'Pending Discharge',
                route: 'morgue.current-discharge.index'
            },
            {
                icon: 'plus',
                name: 'Admission Report',
                route: 'morgue.admission-report.index'
            },
            {
                icon: 'plus',
                name: 'Discharge Report',
                route: 'morgue.discharge-report.index'
            }, {
                icon: 'plus',
                name: 'Orders',
                route: 'inventory-management.orders.index'
            },
        ],
    }, {
        icon: 'folder-open',
        name: 'REPORTS',
        expand:false,
        children: [
            {
                icon: 'syringe',
                name: 'Patient Reports',
                route: `reports.patients`,
            },
            {
                icon: 'syringe',
                name: 'Accounts & Finance',
                route: `reports.accounts-finance.index`,
            },{
                icon: 'syringe',
                name: 'Accounting & Financing',
                route: `reports.accounts-finance.invoicingindex`,
            },
        ],
    },
   
    {
        icon: 'users',
        name: 'ADMIN',
        expand:false,
        children: [
            {
                icon: 'list',
                name: 'Users',
                route: 'admin.users.index',
            },
            {
                icon: 'plus',
                name: 'Roles',
                route: 'admin.roles.index'
            },
            {
                icon: 'plus',
                name: 'Assign Rights To Role',
                route: 'admin.role-rights.index'
            },
            {
                icon: 'plus',
                name: 'Assign Rights To Roles',
                route: 'admin.role-rights-grouped.index'
            },
            {
                icon: 'plus',
                name: 'User Configs',
                route: 'admin.configs.index'
            },{
                icon: 'plus',
                name: 'Audit Trail',
                route: 'admin.audittrail.index'
            },
        ],
    }, {
        icon: 'cogs',
        name: 'MASTER DATA',
        expand: false,
        children: [
            {
                icon: 'list',
                name: 'Accounts Master Data',
                route: 'master-data.accounts.index'
            },
            {
                icon: 'list',
                name: 'HMIS Master Data',
                route: 'master-data.index'
            },
        ],
    },
];
